// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__LKKmV","footer":"ReportModalFilter_footer__2ryPe"};